import {Box, Grid2, Paper, Tooltip, Typography} from "@mui/material";
import {ReactNode} from "react";

interface MultiSelectorCardProps<T> {
  onSelect: (fileType: T) => void;
  selected?: T | null;
  options: T[];
}

export function MultiSelectorCard<T extends {
  type: string;
  icon?: ReactNode;
  tooltip?: string;
  label?: string;
  isAvailable?: boolean
}>(
  {onSelect, options, selected}: MultiSelectorCardProps<T>
) {
  return (
    
    <Grid2 container spacing={3}>
      {options.map((fileType) => (
        <Grid2 size={{xs: 12, sm: 6, md: 4}} key={fileType.type}>
          <Tooltip
            title={fileType.tooltip}>
            <Paper
              sx={{
                p: 3,
                height: 180,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                color: "inherit",
                borderRadius: 3,
                border: selected?.type === fileType.type ? '2px solid' : '2px solid transparent',
                borderColor: selected?.type === fileType.type ? 'primary.main' : 'divider',
                backgroundColor: 'background.paper',
                cursor: fileType.isAvailable ? "pointer" : "not-allowed",
                "&:hover": {
                  boxShadow: fileType.isAvailable ? 2 : 0,
                  borderColor: fileType.isAvailable ? 'primary.main' : 'divider',
                },
              }}
              onClick={() => onSelect(fileType)}
            >
              <Box sx={{
                p: 2,
                borderRadius: '50%',
                bgcolor: 'primary.lighter',
                mb: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {fileType.icon}
              </Box>
              <Typography
                variant="h6"
                sx={{
                  mt: 1,
                  fontWeight: 600,
                  textAlign: 'center'
                }}
              >
                {fileType.label}
              </Typography>
            </Paper>
          </Tooltip>
        </Grid2>
      ))}
    </Grid2>
  
  )
}